<template>
  <v-container class="d-flex justify-center align-center pt-10">
    <elevated-card
    width="500">
      <v-form
      v-model="isFormValid"
      class="mb-7">
        <v-row
        dense
        no-gutters>
          <v-col
          v-if="isLoading" 
          class="pt-8">
            <div
            class="new-user-title-box d-flex justify-center align-center">
              <infinite-loader
              color="white"
              size="35"/>
            </div>
          </v-col>
          <v-col 
          v-else
          class="pt-8">
            <div
            :class="`${getDecisionAsString() === 'APPROVAL' ? 'new-user-title-box' : 'new-user-title-box-error'} d-flex justify-center align-center`">
              <span>{{ getDecisionAsString() === 'APPROVAL' ? $t('pages.requestAccount.approvedCardTitle') : $t('pages.requestAccount.rejectedCardTitle') }}</span>
              <v-icon dark class="ml-2">
                {{ getDecisionAsString() === 'APPROVAL' ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline'}}
              </v-icon>
            </div>
          </v-col>
        </v-row>
        <contact-fields
        :first-name.sync="contact.firstName"
        :last-name.sync="contact.lastName"
        :phone.sync="contact.phone"
        :email.sync="contact.email"
        readonly/>

        <address-fields
        :company-name.sync="address.companyName"
        :country.sync="address.country"
        :province.sync="address.province"
        :city.sync="address.city"
        :postal-code.sync="address.postalCode"
        :street.sync="address.street"
        :building.sync="address.building"
        readonly/>
        <text-field-select-role
        v-if="isApproval"
        v-model="contact.role"
        required
        class="mt-3"
        item-text="value"
        item-value="key"
        :roles-only="['CLIENT', 'SUSTAINABILITY_MANAGER']"
        :disabled="!canUpdate"/>

        <select-clients-list
        v-if="isApproval"
        v-show="allowSelectingClients"
        :clients.sync="selectedClients"
        :disabled="!canUpdate"/>

        <v-row
        class="mt-8"
        dense
        no-gutters>
          <v-col class="d-flex justify-center align-center">
            <primary-btn
            @click="tryToSetDecision"
            :disabled="!isFormValid || !canUpdate"
            :label="$t('btns.submit')"
            :loading="isLoading"
            color='#0277bd'
            :width="150"
            :height="50"
            />
          </v-col>
        </v-row>
      </v-form>
    </elevated-card>
  </v-container>
</template>
<script>
import ElevatedCard from '@/components/cards/ElevatedCard'
import ContactFields from '@/components/group-fields/ContactFields'
import AddressFields from '@/components/group-fields/AddressFields'
import TextFieldSelectRole from '@/components/text-fields/TextFieldSelectRole'
import SelectClientsList from '@/components/lists/dynamic/SelectClientsList'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
import InfiniteLoader from '@/components/common/InfiniteLoader'
import { execHttpRequestThrowable } from '@/services/http'
import { fetchRequestAccountById, setRequestAccountDesicion } from '@/repositories/contactRepo'
import { getRoleByKey } from '@/utils/rolesUtil'
import { routeFromRoot } from '@/services/routeService'
export default {
  components: {
    ElevatedCard,
    ContactFields,
    AddressFields,
    TextFieldSelectRole,
    SelectClientsList,
    PrimaryBtn,
    InfiniteLoader
  },
  data() {
    return {
      contact: {
        id: null,
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        role: null
      },
      address: {
        companyName: '',
        country: '',
        province: '',
        city: '',
        postalCode: '',
        street: '',
        building: ''
      },
      status: null,
      selectedClients: [],
      isFormValid: false,
      isLoading: false
    }
  },
  computed: {
    allowSelectingClients() {
      return this.contact?.role && this.contact.role === "SUSTAINABILITY_MANAGER"
    },
    canUpdate() {
      return this.status === "WAITING_APPROVAL"
    },
    isApproval() {
      return this.getDecisionAsString() === "APPROVAL"
    }
  },
  methods: {
    async tryToSetDecision() {
      const body = {
        id: this.$route.params.id,
        status: this.getDecisionAsString(),
        additionalInfoJson: this.isApproval ? {
          "role": this.contact.role,
          "clients": this.allowSelectingClients ? this.selectedClients.map(o => {
            const { name, email, raw } = o
            return {
              name,
              username: raw.contact.username,
              email
            }
          }) : null
        } : null
      }
      await execHttpRequestThrowable(async () => await setRequestAccountDesicion(body), 
      {},
      v => this.isLoading = v)
      routeFromRoot('active-repairs')
    },
    async tryToFetchAccountRequestById() {
      const r = await execHttpRequestThrowable(async () => await fetchRequestAccountById(this.$route.params.id),
      {},
      v => this.isLoading = v)
      const { contact, address, status, additionalInfoJson } = r.response.data
      this.contact = contact
      this.address = address
      this.status = status

      if (additionalInfoJson) {
        const { role, clients } = additionalInfoJson
        this.contact.role = getRoleByKey(role)
        if (clients && clients.length > 0) this.selectedClients = [...clients]
      }
    },
    openSuccessDialog(m) {
      this.$successDialog.open(null, m, null)
    },
    openFailedDialog(m) {
      this.$failedDialog.open(null, m, null)
    },
    getDecisionAsString() {
      const d = this.$route.params.decision
      switch(d) {
        case 'approve': return 'APPROVAL'
        case 'reject': return 'REJECTED'
        default: {
          console.error(`Options allowed for decision are: (approve) and (reject)! The system received ${d}`)
          return null
        }
      }
    }
  },
  async mounted() {
    await this.tryToFetchAccountRequestById()

    this.$feedback.fill("Account Request Decision Page", this.$route.path)
  }
}
</script>
<style>

</style>